export default __webpack_public_path__ + "static/media/old_diamond_card_selected.6b14fbf2.png";